import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  majorCategories: null,
  loading: false,
  error: null,
};

const majorCategoriesSlice = createSlice({
  name: 'majorCategories',
  initialState,
  reducers: {
    getMajorCategoriesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getMajorCategoriesSuccess: (state, action) => {
      state.majorCategories = action.payload;
      state.loading = false;
    },
    getMajorCategoriesFailed: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { 
  getMajorCategoriesStart, 
  getMajorCategoriesSuccess, 
  getMajorCategoriesFailed 
} = majorCategoriesSlice.actions;

export default majorCategoriesSlice.reducer;
